<template>
  <div id="paginaVerificaBilancio">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Verifica Bilancio Produzioni</b-card-title>
              <!-- <b-card-text class="mb-0"> Teatro Coccia </b-card-text> -->
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropSpettacoli" ref="dropSpettacoli"
                  :query="querySpettacoli" :dataSource="elencoSpettacoliList"
                  :index="spettacoliIndex" :fields="elencoSpettacoliFields"
                  :enabled="dropSpettacoliEnabled"
                  :change="onSpettacoloChange"
                  v-model="spettacoloCorrente"
                  placeholder="Seleziona uno Spettacolo"
                  :allowFiltering="true"
                  :filtering="spettacoloFiltering"
                ></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>


              <b-col xl="12" md="12" class="mt-4" v-show="mostraRiepilogo">
                <h3>Riepilogo Produzione</h3>
              </b-col>


              <!-- Button:  -->
              <b-col xl="12" md="12" class="mt-3" v-show="mostraRiepilogo">
                <ejs-button id="aggiornaRiepilogoButton" @click.native="aggiornaRiepilogo()">Aggiorna Riepilogo
                </ejs-button>
              </b-col>


              <b-col xl="12" md="12" class="mt-1" v-show="mostraRiepilogo">

                <b-card tag="article" class="mb-2">
                  <b-card-header class="align-items-baseline">
                    <div>
                      <b-card-title>Totali</b-card-title>
                      <b-card-text class="mb-0" />
                    </div>
                  </b-card-header>
                  <b-card-body class="mb-0">
                    <!-- card body -->
                    <b-row>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePreventivo" class="h5">Totale Preventivo</label>
                        <ejs-numerictextbox id="totalePreventivo" v-model="totalePreventivo"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Preventivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleConsuntivo" class="h5">TotaleConsuntivo</label>
                        <ejs-numerictextbox id="totaleConsuntivo" v-model="totaleConsuntivo"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Consuntivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="scostamento" class="h5">Scostamento</label>
                        <ejs-numerictextbox id="scostamento" v-model="scostamento"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Preventivo - Consuntivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="raggiungimentoPerc" class="h5">Raggiungimento %</label>
                        <ejs-numerictextbox id="raggiungimentoPerc" v-model="raggiungimentoPerc"
                          floatLabelType="Never" cssClass="" format="###.##" placeholder="Raggiungimento %"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>

                    </b-row>
                  </b-card-body>
                </b-card>

              </b-col>

              <!-- Button:  -->
              <b-col xl="12" md="12" class="mt-0" v-show="mostraRiepilogo">
                <ejs-button id="downloadExcel" @click.native="downloadXls(false)">Scarica Excel</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import { LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin,
  LinkPlugin, AlertPlugin, ToastPlugin,
} from "bootstrap-vue";
// import Vuexy
import { Query } from "@syncfusion/ej2-data";

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiSpettacoloUrl = "/demo/api/spettacolo"
const apiBilancioProduzioneUrl = '/demo/api/costoproduzioni/export_bilancio_produzione'
const apiBilancioProduzioneXlsUrl = '/demo/api/costoproduzioni/export_bilancio_produzione_xls'
// API ricerca distinte per anno

export default Vue.extend({
  components: {},
  data() {
    return {
      initial: true,
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // praticheVVF
      entrateBilancioMinistero: [],
      usciteBilancioMinistero: [],
      tot_prev_entrate: 0,
      tot_cons_entrate: 0,
      tot_prev_uscite: 0,
      tot_cons_uscite: 0,

      // per inizializzazione dropdown a null
      initIndex: -1,
      // per gestione conto
      soggettiList: [],
      tipoFields: { text: "label", value: "val" },

      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      annoRiferimentoCorrente: null,
      // per gestione spettacoli
      elencoSpettacoliList: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,
      dropSpettacoliEnabled: false,
      downloadxlsEnabled: false,
      querySpettacoli: null,
      spettacoloCorrente: null,
      spettacoloCorrenteHasMinistero: null,
      spettacoloCorrenteTitolo: null,

      totalePreventivo: null, // leggerà da backend
      totaleConsuntivo: null,
      scostamento: null,
      raggiungimentoPerc: null,
      incassiBiglAnnui: null,

      mostraRiepilogo: false,
      evidenzia: 0,

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Download riepilogo",
            tooltipText: "Download riepilogo",
            prefixIcon: "e-save",
            id: "download-riepilogo",
          },
          "Search",
        ],
        groupOptions: { showDropArea: false, columns: ['gruppo'] },
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
    };
  },
  created() {
    console.log("Pagina Verifica Bilancio Creata");
    // inizializzazione elenchi dal backend

    // spettacoli
    useJwt.get(apiSpettacoloUrl).then((d) => {
      // console.log("Elenco Spettacoli");
      // console.log(d.data);
      this.elencoSpettacoliList = d.data;
    });

  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate, Group],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero dati per l'anno selezionato");
      this.querySpettacoli = new Query().where(
        "stagione",
        "equal",
        this.$refs.dropAnniRiferimento.ej2Instances.value
      );
      this.dropSpettacoliEnabled = true;
      this.downloadxlsEnabled = true;
      // reset campo spettacolo
      this.$refs.dropSpettacoli.ej2Instances.value = null
      this.$refs.dropSpettacoli.ej2Instances.dataBind()
    },

    onSpettacoloChange: function (e) {
      // abilito gridA
      // this.$refs.gridA.$el.classList.remove("disablegrid");
      // document.getElementById("GridParent").classList.remove("wrapper");
      // recupero info sul fatto che lo spettacolo abbia il ministero
      this.elencoSpettacoliList.forEach((obj) => {
        if (obj.id === this.spettacoloCorrente) {
          this.spettacoloCorrenteHasMinistero = obj.ministero;
          this.spettacoloCorrenteTitolo = obj.titolo;
        }
      })
      console.log(this.spettacoloCorrente)
      console.log(this.spettacoloCorrenteHasMinistero)
      // Azzero i totali
      this.totalePreventivo = null;
      this.totaleConsuntivo = null;
      this.scostamento = null;
      this.raggiungimentoPerc = null;
      // mostro il riepilogo
      this.mostraRiepilogo = true;
      // abilito tasti download

    },
    spettacoloFiltering: function (e) {
      var searchData = this.elencoSpettacoliList;
      var query = new Query();
      query =
        e.text != "" ? query.where("titolo", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },

    aggiornaRiepilogo: function (args) {
      console.log("Aggiorna Riepilogo")
      // ottieni preventivo, consuntivo da backend

      const datiDaInviare = {
        anno: this.annoRiferimentoCorrente,
        spettacolo: this.spettacoloCorrente,
      };
      useJwt.post(apiBilancioProduzioneUrl, datiDaInviare).then((r) => {
        console.log("RIEPILOGO PRODUZIONE")
        console.log(r.data)
        this.totalePreventivo = r.data['tot_preventivo']
        this.totaleConsuntivo = r.data['tot_consuntivo']
        this.evidenzia = r.data['flag']
        this.scostamento = this.totaleConsuntivo - this.totalePreventivo;
        if ((this.totalePreventivo > 0) && (this.totaleConsuntivo > 0)) {
          this.raggiungimentoPerc = 100*this.totaleConsuntivo/this.totalePreventivo;
        } else { this.raggiungimentoPerc = null; }
        console.log(`evidenzia ${this.evidenzia}`)
        if (this.evidenzia === 1) {
          document.getElementById('totaleConsuntivo').style.color = "#0000FF";
        }
      })

    },
    // per dialogA

    downloadXls: function() {
      // scarico statistiche spettacolo
      const datiDaInviare = {
        anno: this.annoRiferimentoCorrente,
        spettacolo: this.spettacoloCorrente,
      };
      useJwt.post(apiBilancioProduzioneXlsUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },
 
    gridBClickHandler(args) {
      // pulsante da implementare
      if (args.item.id === "new") {
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
